export const BASE_FORM_KEYS: string[] = [
  'PDP',
  'CONTACT_INFO',
  'CONTACT_SELL',
  'PARTS',
  'SERVICE',
  'VAN_UP',
  'NEWSLETTER',
  'INQUIRY',
  'EVENT',
];

export interface IDynamicsFieldMapping {
  DataverseFieldName: string;
  DataverseFieldValue: string;
}

export interface IDynamicsRequestBody {
  formKey: string;
  formName: string;
  mappings: unknown[];
  publishedFormUrl?: string;
  customDynamicsFormId?: string;
}

export interface IDynamicsResponse {
  success: boolean;
  error?: string;
}

export interface IDynamicsOption {
  Value: number;
  Label: {
    LocalizedLabels: {
      Label: string;
    }[];
  };
}

export type IDynamicsOptionSet = {
  DataverseValue: number;
  Label: string;
}[];

export enum DynamicsLeadType {
  buyer = 10,
  seller = 11,
  service = 12,
  parts = 13,
  marketing = 15,
}

export enum DynamicsLeadSource {
  'down-phone-call' = 1,
  'rv-experience' = 2,
  'radio' = 3,
  'facebook-marketplace' = 5,
  'google-search' = 6,
  'facebook-not-marketplace' = 7,
  'instagram' = 8,
  'tv' = 10,
  'rvusacom' = 11,
  'rvtradercom' = 12,
  'rvuniversecom' = 14,
  'la-mesa-email-response' = 17,
  'bing' = 18,
  'rvshowusacom' = 22,
  'buyer-dept-trade-in-lead' = 23,
  'referral' = 24,
  'repeat-customer' = 25,
  'service-customer' = 26,
  'engage-to-sell' = 29,
  'walk-in' = 31,
  'rep-youtube-video' = 32,
  'rv-show-email-response' = 33,
  'rv-show' = 40,
  'website-online-inquiry' = 41,
  'internet-phone-call' = 1000,
  'manufacturer-lead' = 1001,
}

export enum DynamicsDealershipType {
  phoenix = 10,
  mesa = 11,
  tucson = 12,
  fremont = 13,
  westSacramento = 14,
  sanDiego = 15,
  albuquerque = 16,
  orlando = 17,
  portStLucie = 18,
  ftMyers = 19,
  davie = 20,
}

export enum DynamicsServiceCenterType {
  phoenix = 10,
  tucson = 11,
  elCajon = 12,
  davis = 13,
  orlando = 14,
  portStLucie = 15,
  ftMyers = 16,
  albuquerque = 17,
}

export enum DynamicsDealershipContactType {
  any = 1,
  email = 2,
  call = 3,
  text = 6,
}
